<template>
  <!-- <app-template-area :area-id="13" /> -->
  <div class="experiencesCarousel">
    <div class="experiencesCarousel__intro text-center">
      <h3>Experiences</h3>
      <p>A private boat to a secret beach, dinner prepared by a renowned chef, that festival on the hill -  the knowledge of our local experts creates experiences that become memories.</p>
    </div>

    <div class="experiencesEnclosure">
      <ssr-carousel
        v-model="currentslide"
        :slides-per-page="1"
        :paginate-by-slide="true"
        :center="false"
        :loop="true"
        :show-arrows="true"
        :overflow-visible="true"
        :gutter="24"
        peek-left="-880"
        peek-right="904"
        class="experiences"
        :responsive="[
          {
            maxWidth: 1024,
            slidesPerPage: 1,
            paginateBySlide: true,
            center: true,
            gutter: 24,
            peekLeft: -720,
            peekRight: 744
          },
          {
            maxWidth: 800,
            slidesPerPage: 1,
            paginateBySlide: true,
            center: false,
            gutter: 8,
            peekLeft: &quot;5%&quot;,
            peekRight: &quot;5%&quot;
          }
        ]"
      >
        <app-link v-for="(d, i) in experiences" :id="d.id" :key="i" :type="d.type" class="slide link-unstyle" :class="{ 'expand': i == currentslide }">
          <div class="slide--holder">
            <div class="slide--image lazyload" :style="getBackground(d)" :alt="d.title" />
          </div>
          <div class="slide--content text-dark">
            <p class="slide--content_title" v-html="d.title" />
            <p class="slide--content_text" v-html="d.text" />
          </div>
        </app-link>
        <template #back-arrow="{ disabled }">
          <img alt="&#10094;" :class="{ 'disabled': disabled }" src="../assets/img/src/icons/left.svg" width="13" height="13">
        </template>

        <template #next-arrow="{ disabled }">
          <img alt="&#10095;" :class="{ 'disabled': disabled }" src="../assets/img/src/icons/right.svg" width="13" height="13">
        </template>
      </ssr-carousel>
    </div>

    <div class="experiencesCarousel__cta text-center">
      <app-link id="40" type="page" class="btn-secondary-dark-sm">
        Discover Experiences
      </app-link>
    </div>
  </div>
</template>

<script>
import SsrCarousel from 'vue-ssr-carousel';
import SsrCarouselCss from 'vue-ssr-carousel/index.css';
import AppLink from './AppLink.vue';

export default {
  name: 'ExperienceCarousel',
  components: { AppLink, SsrCarousel, SsrCarouselCss },
  data() {
    return {
      experiences: [
        {
          image: '/media/Think Experiences/Rebrand_experiences/Gastronomic_inspiration.jpg',
          title: 'Gastronomic inspiration',
          text: 'Immersing yourself in the gastronomic life of the locals is a cultural experience that’s not to be missed in our destinations. From in-villa cooks and street food tours, to private cookery lessons - discover our gastronomic experiences here.',
          type: 'page',
          id: 1033,
        },
        {
          image: '/media/Think Experiences/Rebrand_experiences/Take_to_the_water.jpg',
          title: 'Take to the water',
          text: 'No holiday in our destinations would be complete without spending a day or two on the water, cruising in style on a private skippered charter, renting a boat for a couple of days, or enjoying a spot of windsurfing, kayaking or scuba diving.',
          type: 'page',
          id: 1034,
        },
        {
          image: '/media/Think Experiences/Rebrand_experiences/Stay_curious.jpg',
          title: 'Stay curious',
          text: 'Unravelling the history of the Mediterranean is easy with our expert guides, whose in-depth knowledge will bring to life the vast heritage of our destinations. Explore fascinating guided archaeological, city and walking tours here.',
          type: 'page',
          id: 1037,
        },
        {
          image: '/media/Think Experiences/Rebrand_experiences/Thrilling_Adventures.jpg',
          title: 'Thrilling adventures',
          text: 'Few adventures are as thrilling as island helicopter flights, guided treks high into rugged mountains, or bike ride along stunning stretches of coastline. Discover our top adventures in the Mediterranean.',
          type: 'page',
          id: 1032,
        },
        {
          image: '/media/Think Experiences/Rebrand_experiences/Tasting_notes.jpg',
          title: 'Tasting notes',
          text: 'Nowhere in the world is winemaking so historically and culturally intrinsic to life as in the heart of the Mediterranean, and our Dionysian experiences are designed to help you explore and enjoy these oenological traditions to the full.',
          type: 'page',
          id: 1035,
        },
      ],
      currentslide: 0,
    };
  },
  computed: {

  },
  methods: {
    getBackground(d) {
      const image = d.image.replaceAll(' ', '%20');
      return {
        backgroundImage: `url(https://www.thethinkingtraveller.com${image})`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/styles/settings/_config.scss';

.experiencesCarousel {
  padding: 1em;
  width: 100%;
  overflow: hidden;
  background-color: $stoneCream;
  &__intro {
    max-width: 1152px;
    margin: 3em auto;
    h3 {
      margin: 1em 0 3em;
      font-size: 18px;
      @media screen and (min-width: 480px) {
        font-size: 24px;
      }
    }
    & p {
      font-family: $font-family-editorial;
      margin: 2em auto;
      font-weight: 200;
      font-size: 28px;
      @media screen and (min-width: 480px) {
        font-size: 32px;
      }
    }
  }

  .experiencesEnclosure {
    position: relative;
    margin: 0 -1em;

    .experiences {
      max-width: 904px;
      display: flex;
      margin: 0 auto;
      flex: none;
      @media screen and (min-width: 800px) and (max-width: 1024px) {
        max-width: 744px;
      }

      &::-webkit-scrollbar-track {
        background-color: transparent;
      }
      &::-webkit-scrollbar-thumb {
        background: transparent;
      }
      &::v-deep .ssr-carousel-slides {
        position: initial !important;
      }
      .slide {
        display: block;
        width: 90vw;
        flex-shrink: initial;
        @media screen and (min-width: 800px) {
          width: 720px;
        }
        @media screen and (min-width: 1024px) {
          width: 880px;
        }

        &--holder {
          width: 100%;
          height: 45vh;
          max-height: 350px;
          padding-top: 1px;
          overflow: hidden;
          @media screen and (min-width: 800px) {
            height: 50vh;
            max-height: 480px;
            width: 720px;
          }
          @media screen and (min-width: 1024px) {
            height: 55vh;
            max-height: 586px;
            width: 880px;
          }
        }
        &--image {
          width: 100%;
          height: calc(45vh - 50px);
          max-height: 300px;
          margin-top: 25px;
          background-size: cover;
          background-position: center;
          transition: all 0.2s ease-in;
          @media screen and (min-width: 800px) {
            height: 100%;
            max-height: initial;
            width: 720px;
            margin-top: 0;
          }
          @media screen and (min-width: 1024px) {
            height: 100%;
            max-height: initial;
            width: 880px;
            margin-top: 0;
          }
        }
        @media screen and (max-width: 800px) {
          &.expand .slide--image {
            height: 45vh;
            max-height: 350px;
            margin-top: 0;
          }
        }
        &--content {
          margin: 1em auto;
          padding: 0 2em;
          text-align: center;
          max-width: 720px;
          &_title {
            font-size: 32px;
            font-family: $font-family-editorial;
            @media screen and (min-width: 480px) {
              font-size: 40px;
            }
          }
          &_text {
            font-size: 14px;
            @media screen and (min-width: 480px) {
              font-size: 16px;
            }
          }
        }
      }

      &::v-deep .ssr-carousel-arrows button {
        cursor: pointer;
        position: absolute;
        top: 170px;
        left: 8px;
        width: 26px;
        height: 26px;
        background: $stoneWhite;
        color: $darkBlack;
        font-weight: bold;
        font-size: 18px;
        transition: 0.6s ease;
        border-radius: 13px;
        user-select: none;
        text-align: center;
        border: 1px solid $yellowStone;
        line-height:13px;
        @media screen and (min-width: 800px) {
          top: 25vh;
          left: 24px;
        }
        @media screen and (min-width: 1024px) {
          top: 27.5vh;
          left: 24px;
        }

        &:focus {
          outline: 0;
        }

        &.ssr-carousel-next-button {
          left: initial;
          right: 8px;
          @media screen and (min-width: 800px) {
            right: 24px;
          }
        }
      }
    }
  }

  &__cta {
    padding: 3em 0;
    text-align: center;
  }
}

</style>
